import React, {useEffect, useMemo, useRef, useState} from "react";
import {useIntl} from "react-intl";
import {useLocation} from "react-router-dom";
import classNames from "classnames";
import Tooltip from "../../component/Tooltip";
import {StarIcon} from "@heroicons/react/24/outline";
import useUpdateWorkspaceImportant, {
    WorkspaceUpdateImportantRequest
} from "../../query/workspace/useUpdateWorkspaceImportant";
import moment from "moment";
import {WorkspaceAggregation} from "@/model/workspace";

const WorkspaceRow: React.FC<{
    className?: string,
    workspace: WorkspaceAggregation,
    redirect: () => void
}> = ({className, workspace, redirect}) => {
    const intl = useIntl();

    const {mutateAsync: workspaceUpdateImportantRequest} = useUpdateWorkspaceImportant(workspace._id);


    const onClickEnterWorkspaceDetail = (e: React.MouseEvent) => {
        e.preventDefault();
        redirect();
    };

    const workspaceName = useMemo(() => {
        return workspace.name ?? `${workspace.user?.fullName}'s Workspace`
    }, [workspace])

    const onClickImportant = async (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        const body: WorkspaceUpdateImportantRequest = {
            important: !workspace.important
        }
        await workspaceUpdateImportantRequest(body);
    }
    if (!workspace) {return <div></div>;}
    return (
        <tr className={"h-16 text-sm text-black font-[350] overflow-auto relative border-b hover:bg-gray-100 " + className || ""}>
            <TooltipTd className={"p-2.5 whitespace-nowrap font-medium text-[14px]"}
                       textClassName={classNames('flex items-center justify-center cursor-pointer space-x-[10px] truncate hover:text-blue-500 hover:underline', {'text-red-500': workspace.deleted})}
                       onClick={onClickEnterWorkspaceDetail}>
                <div>
                    {workspace.deleted
                        ? `${workspaceName} (${intl.formatMessage({id: "i10023"})})`
                        : workspaceName
                    }
                </div>

                <button onClick={(e) => {
                    onClickImportant(e)}}
                >
                    <StarIcon className={classNames("w-5 h-5", workspace.important && "fill-yellow-400")}/>
                </button>
            </TooltipTd>
            <TooltipTd className={"p-2.5 whitespace-nowrap text-[14px]"}>
                {workspace.workspaceSubscription?.plan.name}
            </TooltipTd>

            <TooltipTd className={"p-2.5 whitespace-nowrap text-[14px]"}>
                {/*<div>*/}
                {/*    {workspace.workspaceSubscription && intl.formatNumber(workspace.workspaceSubscription.currentUsage.message)}/*/}
                {/*    {workspace.workspaceSubscription && intl.formatNumber(workspace.workspaceSubscription.plan.usageLimit.message + workspace.workspaceSubscription.forwardedLimit.message)}</div>*/}
                {/*<div>*/}
                {/*    {*/}
                {/*        workspace.workspaceSubscription?.forwardedLimit.message !== 0 && workspace.workspaceSubscription &&*/}
                {/*        `(지난 요금제 잔여량: ${intl.formatNumber(workspace.workspaceSubscription.forwardedLimit.message)})`*/}
                {/*    }*/}
                {/*</div>*/}
            </TooltipTd>
            <TooltipTd className={"p-2.5 whitespace-nowrap text-[14px]"}>
                {workspace.user?.email ?? <div className="text-red-500 font-medium">{intl.formatMessage({id: "i1006"})}</div>}
            </TooltipTd>
            <TooltipTd className={"p-2.5 whitespace-nowrap text-[14px]"}>
                {workspace.deleted ?
                    <div>
                        <div>
                            생성 일자: {moment.utc(workspace.createdAt).local().format("YYYY-MM-DD HH:mm:ss")}
                        </div>
                        <div>
                            삭제 일자: {moment.utc(workspace.updatedAt).local().format("YYYY-MM-DD HH:mm:ss")}
                        </div>
                    </div>
                    :
                    <div>
                        {moment.utc(workspace.createdAt).local().format("YYYY-MM-DD HH:mm:ss")}
                    </div>
                }
            </TooltipTd>
        </tr>
    );
};

interface TooltipTdProps {
    className?: string
    textClassName?: string
    children: React.ReactNode
    onClick?: (e: React.MouseEvent) => void
}

const TooltipTd: React.FC<TooltipTdProps> = (props) => {
    const {className, textClassName, children, onClick} = props;

    const location = useLocation();
    const tdRef = useRef<HTMLTableDataCellElement>(null);
    const textRef = useRef<HTMLDivElement>(null);
    const [isTextEclipsed, setIsTextEclipsed] = useState<boolean>(false);

    const _className = useMemo(() => {
        return classNames("relative", {[className ?? '']: className});
    }, [className]);

    const _textClassName = useMemo(() => {
        return classNames("truncate", {[textClassName ?? '']: textClassName});
    }, [textClassName]);

    useEffect(() => {
        const textElem = textRef.current

        if (textElem) {
            setIsTextEclipsed(textElem.offsetWidth < textElem.scrollWidth);
        }
    }, [location])

    const onClickContent = (e: React.MouseEvent) => {
        onClick && onClick(e);
    }

    return (
        <td className={_className}
            ref={tdRef}>
            <div className="flex">

                <div ref={textRef}
                     className={_textClassName}
                     onClick={onClickContent}>
                    {children}
                </div>
            </div>
            <Tooltip targetRef={tdRef}
                     content={children}
                     disabled={!isTextEclipsed} />
        </td>
    );
}

export default WorkspaceRow;
